import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/customers/')({
  loader: () => {
    throw redirect({
      to: '/customers/stores',
    })
  },
})
